var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA3952",
    fillRule: "evenodd",
    d: "M11.07 2.043a2.914 2.914 0 013.922 1.029l.002.004L23.1 16.612l.009.014a2.915 2.915 0 01-2.491 4.37H4.381a2.914 2.914 0 01-2.49-4.371l.008-.014 8.09-13.507.018-.032a2.93 2.93 0 011.062-1.03m1.43 1.625a.91.91 0 00-.78.437L3.62 17.63a.914.914 0 00.78 1.365h16.2a.914.914 0 00.78-1.365l-8.1-13.522v-.002a.91.91 0 00-.782-.438M12.5 8a1 1 0 011 1v4a1 1 0 11-2 0V9a1 1 0 011-1m-1 8a1 1 0 011-1h.01a1 1 0 010 2h-.01a1 1 0 01-1-1",
    clipRule: "evenodd"
  })));
}

export default SvgWarningTriangle;